


































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { IGuest } from "@/@types/admin/guest/user";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { getAge } from "@/services/dateTime/getFullDate";
import { pensioners } from "@/config/main.config.json";

interface IRoomLeavel {
  [x: string]: Array<Array<string>>;
}

@Component({})
export default class RoomPlan extends Vue {
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomTypes!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) roomStatuses!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) guests!: Array<IGuest>;
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  @Prop({ type: String, default: "all" }) registrated!: string;
  @Prop({ type: Object, default: null }) sort!: {
    name: string;
    data: string;
  };
  @Prop({ type: String, default: "" }) search!: string;
  @Prop({ type: Boolean, default: true }) show_plan_guests!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_children!: boolean;
  @Prop({ type: Boolean, default: true }) show_plan_pensioners!: boolean;
  @Prop({ type: Boolean, default: false }) show_plan_cell!: boolean;

  waif: Array<IRoom> = [];

  get roomList(): IRoomLeavel {
    const levels: IRoomLeavel = {};
    this.waif = [];
    const levels_id: Array<string> = [];
    this.roomLevels.forEach((el) => levels_id.push(el._id));

    const maximus: { [x: string]: { x: string; y: string } } = {};
    let maxx = 0;
    this.rooms.forEach((el) => {
      if (
        el.level &&
        el.position &&
        el.position.x !== null &&
        el.position.x !== undefined &&
        el.position.y !== null &&
        el.position.y !== undefined &&
        levels_id.includes(el.level)
      ) {
        const x =
          maximus[el.level] && maximus[el.level].x
            ? parseInt(maximus[el.level].x) < parseInt(el.position.x)
              ? el.position.x
              : maximus[el.level]?.x
            : String(0);
        const y =
          maximus[el.level] && maximus[el.level].y
            ? parseInt(maximus[el.level].y) < parseInt(el.position.y)
              ? el.position.y
              : maximus[el.level]?.y
            : String(0);
        maximus[el.level] = { x, y };

        maxx = maxx < parseInt(x) ? parseInt(x) : maxx;
      }
    });

    if (!Object.keys(maximus).length) return levels;

    this.roomLevels.forEach((el) => {
      const y = maximus[el._id] ? parseInt(maximus[el._id].y) : 0;
      const x = maximus[el._id] ? parseInt(maximus[el._id].x) + 1 : 0;

      levels[el._id] = new Array(y ? y + 1 : 0);
      for (let i = 0; i < levels[el._id].length; i++) {
        this.$set(levels[el._id], i, new Array(x ? x : 0).join("*").split(""));
      }
    });

    this.rooms.forEach((el) => {
      if (
        !el.level ||
        !el.position ||
        el.position.x === null ||
        el.position.x === undefined ||
        el.position.y === null ||
        el.position.y === undefined ||
        !levels_id.includes(el.level)
      )
        this.waif.push(el);
      else {
        const x = parseInt(el.position.x);
        const y = parseInt(el.position.y);

        let j = 0;
        while (!levels[el.level][y]) {
          if (j > 5) {
            this.dangerError();
            break;
          }
          j++;
          levels[el.level].push([]);
        }

        let i = 0;
        while (!levels[el.level][y][x]) {
          if (i > 250) {
            this.dangerError();
            break;
          }
          i++;
          levels[el.level][y].push("*");
        }
        levels[el.level][y][x] = JSON.parse(JSON.stringify(el._id));
      }
    });
    return levels;
  }

  dangerError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "error",
    });
  }

  getLevelName(id: string): string {
    const level = this.roomLevels.find((el) => el._id == id);
    return level ? this.$getLocale(level.name) : "-";
  }

  getType(type: string): string {
    const t = this.roomTypes.find((el) => el._id == type);
    if (t) return this.$getLocale(t.name);
    return type ? `<code>${type}</code>` : "";
  }

  getRoomStatus(type: string): string {
    const t = this.roomStatuses.find((el) => el._id == type);
    if (t) return this.$getLocale(t.name);
    return type ? `<code>${type}</code>` : "";
  }

  getRoom(room_id: string): Partial<IRoom> {
    const room = this.rooms.find((el) => el._id == room_id);
    return room ? room : { _id: room_id };
  }

  getRoomGuests(roomId: string): Array<IGuest> {
    const guests: Array<IGuest> = [];
    this.guests.forEach((guest) => {
      if (guest.stay_data?.room?.id != roomId) return;
      if (!guest.stay_data.arrival || !guest.stay_data.departure) return;
      const arrival = new Date(guest.stay_data.arrival);
      const departure = new Date(guest.stay_data.departure);
      const today = new Date();
      if (today >= arrival && today <= departure) guests.push(guest);
    });
    return guests;
  }

  hasChildren(roomId: string): boolean {
    for (const guest of this.guests) {
      if (guest.stay_data?.room?.id != roomId) continue;
      if (!guest.personal_data || !guest.personal_data.birthday) continue;
      const age = getAge(guest.personal_data.birthday);
      if (age < 18) return true;
    }
    return false;
  }

  hasPensioner(roomId: string): boolean {
    for (const guest of this.guests) {
      if (guest.stay_data?.room?.id != roomId) continue;
      if (!guest.personal_data || !guest.personal_data.birthday) continue;
      const age = getAge(guest.personal_data.birthday);
      if (guest.personal_data.gender == 1 && age >= pensioners.men) return true;
      if (guest.personal_data.gender == 2 && age >= pensioners.women)
        return true;
    }
    return false;
  }

  getRoomBackground(room: IRoom): string {
    const roomId = room._id;

    if (this.isSortActive() && this.roomDisabled(roomId)) {
      return "#e8e8ed";
    }

    const guestsInRoom = this.getRoomGuests(roomId);

    if (guestsInRoom.length) {
      for (const guest of guestsInRoom) {
        if (
          !guest.stay_data ||
          !guest.stay_data.arrival ||
          !guest.stay_data.departure
        )
          return "repeating-linear-gradient(45deg, #ffebee, #ffebee 10px, #ffcdd2 10px, #ffcdd2 20px)";
        const arrival = new Date(guest.stay_data.arrival);
        const departure = new Date(guest.stay_data.departure);
        const today = new Date();
        if (today >= arrival && today <= departure) return "#ffeaa7";
        else return "#ffcdd2";
      }
    }

    if (this.registrated != "new") {
      const vrooma = this.virtualRooms.find((vr) => vr.room == roomId);
      if (vrooma && vrooma.guests) {
        for (const guestId of vrooma.guests) {
          const guest = this.guests.find((g) => g._id == guestId);
          if (!guest) continue;
          if (
            !guest.stay_data ||
            !guest.stay_data.arrival ||
            !guest.stay_data.departure
          )
            return "repeating-linear-gradient(45deg, #ffebee, #ffebee 10px, #ffcdd2 10px, #ffcdd2 20px)";
          const arrival = new Date(guest.stay_data.arrival);
          const departure = new Date(guest.stay_data.departure);
          const today = new Date();
          if (today >= arrival && today <= departure) return "#ffeaa7";
          else return "#ffcdd2";
        }
      }
    }

    const guest = this.guests.find((g) => g.stay_data?.room?.id == roomId);
    if (guest) {
      if (
        !guest.stay_data ||
        !guest.stay_data.arrival ||
        !guest.stay_data.departure
      )
        return "repeating-linear-gradient(45deg, #fff9c4, #fff9c4 10px, #fff59d 10px, #fff59d 20px)";
      const arrival = new Date(guest.stay_data.arrival);
      const departure = new Date(guest.stay_data.departure);
      const today = new Date();
      if (today >= arrival && today <= departure) return "#fff9c4";
    }

    return "#e8e8ed";
  }

  cellStyle(room: IRoom): Record<string, string> {
    const bg = this.getRoomBackground(room);
    if (!bg) return {};
    if (bg.startsWith("repeating-linear")) {
      return {
        background: bg,
        borderColor: bg,
      };
    }
    return {
      background: `${bg}66`,
      borderColor: bg,
    };
  }

  cellStyleById(id: string): Record<string, string> {
    const room = this.rooms.find((el) => el._id == id);
    if (!room) return {};
    const style = this.cellStyle(room);
    return style;
  }

  roomDisabled(id: string): boolean {
    const sortActive = !!(
      this.sort &&
      typeof this.sort.name === "string" &&
      this.sort.name.length > 0 &&
      this.sort.name !== "registered"
    );
    if (!sortActive) return false;

    const roomGuests = this.getRoomGuests(id);
    if (!roomGuests.length) {
      const allGuests = this.getAllRoomGuests(id);
      if (!allGuests.length) return true;
      return !this.guestsMatchCriteria(allGuests);
    }
    return !this.guestsMatchCriteria(roomGuests);
  }

  isSortActive(): boolean {
    return !!(
      this.sort &&
      typeof this.sort.name === "string" &&
      this.sort.name.length > 0 &&
      this.sort.name !== "registered"
    );
  }

  isSearchActive(): boolean {
    return !!(this.search && this.search.trim().length > 0);
  }

  roomMatchesSearch(roomId: string): boolean {
    if (!this.isSearchActive()) return true;
    const room = this.rooms.find((el) => el._id == roomId);
    if (!room) return false;
    const query = this.search.trim().toLowerCase();
    return String(room.name).toLowerCase().includes(query);
  }

  isRoomDimmed(roomId: string): boolean {
    if (this.isSearchActive() && !this.roomMatchesSearch(roomId)) return true;
    if (this.isSortActive() && this.roomDisabled(roomId)) return true;
    return false;
  }

  guestsMatchCriteria(guests: Array<IGuest>): boolean {
    for (const guest of guests) {
      if (this.sort.name === "children") {
        if (!guest.personal_data || !guest.personal_data.birthday) continue;
        const age = getAge(guest.personal_data.birthday);
        const years = this.sort.data.split("-");
        if (
          (years.length === 1 && age == parseInt(years[0])) ||
          (age >= parseInt(years[0]) && age < parseInt(years[1]))
        ) {
          return true;
        }
      } else if (this.sort.name === "pensioners") {
        if (!guest.personal_data || !guest.personal_data.birthday) continue;
        const age = getAge(guest.personal_data.birthday);
        const men = 60;
        const women = 55;
        if (guest.personal_data.gender) {
          if (guest.personal_data.gender == 1 && age >= men) return true;
          if (guest.personal_data.gender == 2 && age >= women) return true;
        }
      } else if (this.sort.name === "birthday") {
        if (!guest.personal_data || !guest.personal_data.birthday) continue;
        if (!guest.stay_data?.arrival || !guest.stay_data?.departure) continue;
        const arrival = new Date(guest.stay_data.arrival);
        const departure = new Date(guest.stay_data.departure);
        const birthdayThisYear = new Date(guest.personal_data.birthday);
        birthdayThisYear.setFullYear(arrival.getFullYear());

        if (this.sort.data === "today") {
          const today = new Date();
          if (
            birthdayThisYear.getDate() == today.getDate() &&
            birthdayThisYear.getMonth() == today.getMonth()
          ) {
            return true;
          }
        } else if (
          birthdayThisYear >= arrival &&
          birthdayThisYear <= departure
        ) {
          return true;
        }
      } else if (this.sort.name === "cruise_code") {
        if (guest.stay_data?.cruise_code === this.sort.data) return true;
      } else if (this.sort.name === "gender") {
        if (guest.personal_data?.gender?.toString() === this.sort.data)
          return true;
      } else if (this.sort.name === "doc_type") {
        if (guest.personal_data?.documents?.doctype === this.sort.data)
          return true;
      } else if (this.sort.name === "citizenship") {
        if (guest.personal_data?.nationality === this.sort.data) return true;
      } else if (this.sort.name === "registered") {
        const id = guest._id || "";
        const vrooma = this.virtualRooms.find((vr) => vr.guests.includes(id));
        const isNew = !vrooma || !vrooma.room;
        if (isNew === (this.sort.data === "new")) return true;
      }
    }
    return false;
  }

  getAllRoomGuests(roomId: string): Array<IGuest> {
    const guests: Array<IGuest> = [];
    this.guests.forEach((guest) => {
      if (guest.stay_data?.room?.id != roomId) return;
      if (!guest.stay_data.arrival || !guest.stay_data.departure) return;
      guests.push(guest);
    });
    return guests;
  }

  cellTitle(room: IRoom): string {
    const parts: string[] = [room.name];
    if (room.type) {
      const typeName = this.getType(room.type);
      if (typeName) parts.push(typeName);
    }
    if (room.area) parts.push(`${room.area}m²`);
    if (room.status) {
      const statusName = this.getRoomStatus(room.status);
      if (statusName) parts.push(statusName);
    }
    return parts.join(" | ");
  }

  cellTitleById(id: string): string {
    const room = this.rooms.find((el) => el._id == id);
    return room ? this.cellTitle(room) : "";
  }
}
